import { CRM_PIPELINE_API } from 'modules/crm/api/crm-pipeline-api'
import { PipelineInterface } from 'modules/crm/types/pipeline-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'

export function usePipelineList(shouldFetch?: boolean) {
  const { user } = useUser()
  const { fetcher } = useFetch<
    RequestMethodsEnum.get,
    DataWithPaginationInterface<Pick<PipelineInterface, 'name' | 'id'>>
  >({ method: RequestMethodsEnum.get })

  const { data: pipelineStage } = useControlledSwr(
    () => {
      if (user && shouldFetch) {
        return `${CRM_PIPELINE_API}/list-all`
      }
    },
    fetcher,
    undefined,
    shouldFetch,
  )
  return { pipelineStage }
}
